
















import { Component, Watch, Mixins } from "vue-property-decorator";
import { Getter, State } from "vuex-class";
import AssetsSelector from "trade/components/instant_trade/AssetsSelector.vue";
import Introduction from "trade/components/instant_trade/Introduction.vue";
import { ATMAsset, ATMPair } from "@foxone/api/src/models/market";
import {
  USDTO_ASSET_ID,
  USDTT_ASSET_ID,
  USDT_ASSET_ID,
  USDTO_META,
  USDT_META
} from "trade/constants";
import mixins from "@/mixins";

@Component({
  components: {
    AssetsSelector,
    Introduction
  }
})
class ConvertUsdt extends Mixins(mixins.page) {
  @State(state => state.trade.pairs) pairs!: ATMPair[];

  @Getter("trade/getAssets") assets!: ATMAsset[];

  offerAmount = "";

  offerAsset: any = "";

  wantedAmount = "";

  wantedAsset: any = "";

  lock = false;

  get title() {
    return this.$t("trade.usdt-exchange") as string;
  }

  get meta() {
    const assets = this.assets.filter(asset =>
      [USDT_ASSET_ID, USDTO_ASSET_ID, USDTT_ASSET_ID].includes(asset.asset_id)
    );
    return {
      assets
    };
  }

  @Watch("offerAmount")
  @Watch("wantedAsset")
  handleOfferAmountChange() {
    if (this.lock) {
      this.lock = false;
      return;
    }
    if (!this.wantedAsset) {
      this.wantedAmount = "";
      return;
    }
    if (this.offerAmount === "") {
      this.wantedAmount = "";
      return;
    }
    if (!this.estimatedRate) {
      return;
    }
    const precision = Math.min(this.wantedAsset.precision + 4, 8);
    const amount = this.$common.utils.number.toPrecision(
      +this.offerAmount * +this.estimatedRate,
      precision
    ) as string;
    if (amount !== this.wantedAmount) {
      this.lock = true;
    }
    this.wantedAmount = amount;
  }

  @Watch("wantedAmount")
  @Watch("offerAsset")
  handleWantAmountChange() {
    if (this.lock) {
      this.lock = false;
      return;
    }
    if (!this.offerAsset) {
      this.offerAmount = "";
      return;
    }
    if (this.wantedAmount === "") {
      this.offerAmount = "";
      return;
    }
    if (!this.estimatedRate) {
      return;
    }
    const precision = Math.min(this.offerAsset.precision + 4, 8);
    const amount = this.$common.utils.number.toPrecision(
      +this.wantedAmount / +this.estimatedRate,
      precision
    ) as string;
    if (amount !== this.offerAmount) {
      this.lock = true;
    }
    this.offerAmount = amount;
  }

  get estimatedRate() {
    const offer = this.offerAsset;
    const wanted = this.wantedAsset;
    if (!offer || !wanted) return "";
    const pair = this.pairs.find(({ base, quote }) => {
      return (
        (quote.asset_id === wanted.asset_id &&
          base.asset_id === offer.asset_id) ||
        (quote.asset_id === offer.asset_id && base.asset_id === wanted.asset_id)
      );
    });
    if (!pair) return "";
    const result =
      pair.base.asset_id === wanted.asset_id ? 1 / +pair.price : pair.price;
    const precision =
      pair.base.asset_id === wanted.asset_id
        ? wanted.precision
        : offer.precision;
    const precisionLimit = Math.min(precision + 4, 8);
    return this.$common.utils.number.toPrecision(result, precisionLimit);
  }

  async mounted() {
    this.$store.dispatch("trade/loadData");
    const wantedAsset = this.assets.find(
      asset => asset.symbol === USDT_META.symbol
    );
    const offerAsset = this.assets.find(
      asset => asset.symbol === USDTO_META.symbol
    );
    // if query specify asset, clear store first, otherwise possiable lead to wrong pair
    if (wantedAsset || offerAsset) {
      this.wantedAsset = "";
      this.offerAsset = "";
    }
    wantedAsset && (this.wantedAsset = wantedAsset);
    offerAsset && (this.offerAsset = offerAsset);
  }
}
export default ConvertUsdt;
